import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { BorderRadiusMedium } from 'autogen/design-tokens/tokens';
import { Disclaimer as DisclaimerTranslation } from 'autogen/translation-keys/trans-website-comai';
import { Button } from 'components/Button';
import { Typography } from 'components/generic/typography';
import Icon from 'components/Icon/Icon';
import Flex from 'components/Layout/components/Flex';
import useComAIStore from '../store/comAIStore';

const TEMP_COLOR_DISCLAIMER_BG = '#ebebeb'; // TODO: Replace with design token

const AIDisclaimerWrapper = styled(Flex.Row)`
    top: ${({ theme }) => theme.Spacing16};
    background-color: ${TEMP_COLOR_DISCLAIMER_BG};
    border-radius: ${BorderRadiusMedium};
    padding: ${({ theme }) => theme.Spacing8} ${({ theme }) => theme.Spacing16};
    padding-right: ${({ theme }) => theme.Spacing8};
    gap: ${({ theme }) => theme.Spacing8};
    align-items: center;
    justify-content: space-between;
    margin: 0 ${({ theme }) => theme.Spacing8};
`;

const Disclaimer = () => {
    const setShowDisclaimer = useComAIStore((state) => state.setShowDisclaimer);
    const { t } = useTranslation();

    return (
        <AIDisclaimerWrapper>
            <Typography.Body>{t(DisclaimerTranslation)}</Typography.Body>
            <Button.WithIcon
                style={{ flexShrink: 0 }}
                variant="ghost"
                icon={<Icon type="Close" size={16} />}
                onClick={() => setShowDisclaimer(false)}
            />
        </AIDisclaimerWrapper>
    );
};

export default Disclaimer;
